<template>
	<div>
		<div id="page-header" class="navbar" :class="{ navbar__open: navOpen }">
            <div class="container-fluid">
                <div class="grid grid-bleed justify-space-between">
                    <div class="col-auto align-self-start">
                        <div class="">
                            <router-link class="account-dropdown" :to="{ name: 'dashboard'}">
                                <img :src="team.logo" class="company-logo">
                                <div class="company">
                                    <div class="company-name">{{ team.name }}</div>
                                    <div class="powered-by">Powered by Squirrel</div>
                                </div>
                            </router-link>
                        </div>
                    </div>

                    <div class="col-auto search-bar">
                        <search :team="team"></search>
                    </div>

                    <div class="col-auto mobile-nav-trigger">
                        <button class="nav-trigger" v-on:click.stop.prevent="toggleNav"><i></i></button>
                    </div>

                    <div class="col-auto account-bar">

                        <a :class="{ dropdown__open: dropdownOpen, dropdown: true }" href="#" role="button" v-on:click.stop.prevent="toggleDropdown">
                            <div class="avatar">
                                <img :src="user.avatar" width="40" class="circle border border-white" v-if="user && user.avatar">
                                <span class="initials circle border border-white" v-if="user && !user.avatar">{{ user.initials }}</span>
                            </div>
                            <svg width="16" height="16" data-icon="caret-down" viewBox="0 0 16 16" style="fill: inherit;">
                                <path d="M12 6.5c0-.28-.22-.5-.5-.5h-7a.495.495 0 00-.37.83l3.5 4c.09.1.22.17.37.17s.28-.07.37-.17l3.5-4c.08-.09.13-.2.13-.33z" fill="#546b81"></path>
                            </svg>

                            <div class="dropdown-menu">

                                <div class="dropdown__group">
                                    <h3>{{ team.name }}</h3>
                                    <div v-if="is_admin">
                                        <router-link class="dropdown-item" :to="{ name: 'settings'}">Settings</router-link>
                                    </div>
                                </div>

                                <div class="dropdown__group">
                                    <ul>
                                        <li>
                                            <router-link class="dropdown-item" :to="{ name: 'view-profile', params: { user: user.id } }">Your profile</router-link>
                                        </li>
                                        <li>
                                            <router-link class="dropdown-item" :to="{ name: 'view-user-posts' }">Your posts</router-link>
                                        </li>
                                        <li>
                                            <router-link class="dropdown-item" :to="{ name: 'groups' }">Your groups</router-link>
                                        </li>
                                    </ul>
                                </div>

                                <div class="dropdown__group">
                                    <a class="dropdown-item" href="/logout" v-on:click.stop.prevent="logout">
                                        Logout
                                    </a>
                                    <form id="logout-form" action="/logout" method="POST" style="display: none;">
                                        <input type="hidden" name="_token" :value="csrf">
                                    </form>
                                </div>
                            </div>
                        </a>

                    </div>
                </div>
                <nav>
                    <ul class="flex main-nav" v-if="team.navigation">
                        <li class="nav-item" v-for="(nav, key) in team.navigation">
                            <router-link v-if="nav.type === 'section' && canViewGroup(nav.url)" class="nav-link" :to="{ name: 'view-group', params: { group: nav.url }}" v-shortkey="['ctrl', (key + 1)]"  @shortkey="changePage()">
                                {{ nav.text }}
                                <svg v-if="nav.children.length !== 0" width="14" height="14" viewBox="0 0 16 16" style="fill: inherit;">
                                    <path d="M12 6.5c0-.28-.22-.5-.5-.5h-7a.495.495 0 00-.37.83l3.5 4c.09.1.22.17.37.17s.28-.07.37-.17l3.5-4c.08-.09.13-.2.13-.33z" fill="#546b81"></path>
                                </svg>
                            </router-link>
                            <a v-if="nav.type === 'custom' && nav.url" class="nav-link" :href="nav.url" :target="nav.url !== '#' && !nav.url.includes('squirrelapp.co.uk') ? '_blank': false">
                                {{ nav.text }}
                                <i v-if="nav.url && nav.url !== '#' && !nav.url.includes('squirrelapp.co.uk')" class="icon ion-md-open"></i>
                                <svg v-if="nav.children.length !== 0" width="14" height="14" viewBox="0 0 16 16" style="fill: inherit;">
                                    <path d="M12 6.5c0-.28-.22-.5-.5-.5h-7a.495.495 0 00-.37.83l3.5 4c.09.1.22.17.37.17s.28-.07.37-.17l3.5-4c.08-.09.13-.2.13-.33z" fill="#546b81"></path>
                                </svg>
                            </a>
                            <router-link v-if="nav.type === 'page' && nav.url !== 'groups'" class="nav-link" :to="{ name: nav.url }">
                                {{ nav.text }}
                                <svg v-if="nav.children.length !== 0" width="14" height="14" viewBox="0 0 16 16" style="fill: inherit;">
                                    <path d="M12 6.5c0-.28-.22-.5-.5-.5h-7a.495.495 0 00-.37.83l3.5 4c.09.1.22.17.37.17s.28-.07.37-.17l3.5-4c.08-.09.13-.2.13-.33z" fill="#546b81"></path>
                                </svg>
                            </router-link>

                            <router-link v-if="nav.type === 'page' && nav.url === 'groups'" class="nav-link" :to="{ name: nav.url }">
                                {{ nav.text }}
                                <svg v-if="nav.children.length !== 0" width="14" height="14" viewBox="0 0 16 16" style="fill: inherit;">
                                    <path d="M12 6.5c0-.28-.22-.5-.5-.5h-7a.495.495 0 00-.37.83l3.5 4c.09.1.22.17.37.17s.28-.07.37-.17l3.5-4c.08-.09.13-.2.13-.33z" fill="#546b81"></path>
                                </svg>
                            </router-link>

                            <ul class="sub-nav" v-if="nav.type === 'page' && nav.url === 'groups'">
                                <li v-for="(group, key) in groups">
                                    <router-link class="nav-link" :to="{ name: 'view-group', params: { group: group.slug }}" v-shortkey="['ctrl', (key + 1)]" @shortkey="changePage()">{{ group.name }}</router-link>
                                </li>
                            </ul>

                            <ul class="sub-nav" v-if="nav.children.length !== 0 && nav.url !== 'groups'">
                                <li v-for="(child, key) in nav.children">
                                    <router-link v-if="child.type === 'section'" class="nav-link" :to="{ name: 'view-group', params: { group: child.url }}" v-shortkey="['ctrl', (key + 1)]"  @shortkey="changePage()">{{ child.text }}</router-link>
                                    <a v-if="child.type === 'custom' && child.url" class="nav-link" :href="child.url" :target="child.url !== '#' && !child.url.includes('squirrelapp.co.uk') ? '_blank': false">{{ child.text }} <i v-if="!child.url.includes('squirrelapp.co.uk')" class="icon ion-md-open"></i></a>
                                    <router-link v-if="child.type === 'page'" class="nav-link" :to="{ name: child.url }">{{ child.text }}</router-link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>

        <div class="content">
        	<slot></slot>
        </div>
	</div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
	export default {
		name: 'LayoutBase',
        data () {
            return {
                is_admin: window.user_can.admin,
                groups: window.groups,
                groupSlugs: window.group_slugs,
                dropdownOpen: false,
                navOpen: false,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                team: state => state.auth.team,
            }),
            ...mapGetters([
                'can',
            ])
        },
        mounted() {},
        methods: {
            logout() {
                if( window.sessionStorage ){
                    window.sessionStorage.clear();
                }
                
                document.getElementById('logout-form').submit();
            },
            toggleDropdown() {
                this.dropdownOpen = (this.dropdownOpen) ? false : true;
            },
            toggleNav() {
                this.navOpen = (this.navOpen) ? false : true;
            },
            changePage(){
            },
            canViewGroup(slug){
                return this.groupSlugs.includes(slug);
            }
        },
        beforeRouteLeave(to, from, next){
            this.dropdownOpen = false;
            next();
        }
	}
</script>
